<script lang="ts">
  import {user} from '@/store';
  import {getInstance} from '../../../../services/animation';
  import editorInstance from '@/lib/editor/editor';
  import DisplayToggle from '../DisplayToggle/DisplayToggle.svelte';
  import {onMount} from 'svelte';
  import Swal from 'sweetalert2';
  export let src: string | undefined;
  let exceedsMaxWidth = false;
  let errorCSS = 'border-gray-300';
  let isUploading = false;

  function openPopup() {
    const fi = document.createElement('input');
    fi.addEventListener('change', fileChanged);
    fi.type = 'file';
    fi.accept = 'image/*';
    fi.click();
  }

  $: errorCSS = exceedsMaxWidth ? 'border-red-500' : 'border-gray-300';

  async function fileChanged(e: any) {
    const file = e.target.files[0];

    if (!file || !['image/png', 'image/jpeg', 'image/svg+xml'].includes(file.type)) {
      Swal.fire({
        position: 'bottom-end',
        icon: 'error',
        title: 'Failed to Upload Logo',
        text: `Make sure your file meets the following requirements: PNG, JPEG, and SVG formats, up to 1024px in width`,
        showConfirmButton: false,
        timer: 10000,
        toast: true
      });
      return;
    }

    try {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.src = objectUrl;
      isUploading = true;

      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
      });

      if (img.width > 1024) {
        exceedsMaxWidth = true;
        URL.revokeObjectURL(objectUrl);
        isUploading = false;
        throw new Error('Image width exceeds 1024px');
      }

      exceedsMaxWidth = false;
      await user.updateLogo(file);
      await user.getBrandKit();

      if (!$user.brandKit) {
        throw new Error('User brandkit not found');
      }

      const brandkit = $user.brandKit;
      src = brandkit.logoUrl;

      const element = getInstance().templateLoader.getAmElement('logo');
      element?.querySelector('img')?.setAttribute('src', brandkit.logoUrl);
    } catch (error) {
      console.error(error);
    } finally {
      isUploading = false;
    }
  }

  $: src = $user.brandKit?.logoUrl;

  function onMouseOver() {
    const logo = document.querySelector("[data-amelement='logo']");
    if (logo) editorInstance.ui.highlight(logo);
  }
  function onMouseLeave() {
    editorInstance.ui.removeHighlight();
  }

  onMount(async () => {
    await user.getBrandKit().then(() => {
      src = $user.brandKit?.logoUrl;
    });
  });
</script>

<div
  id="select_logo"
  class="grid w-full gap-2"
  on:mouseover={onMouseOver}
  on:focus={onMouseOver}
  on:mouseleave={onMouseLeave}
>
  <div class="flex items-center gap-2">
    <span class=" block text-sm font-bold" id="sb-logo">Logo</span>
    <DisplayToggle target="[data-amelement='logo']" />
  </div>
  <div
    on:click|preventDefault|stopPropagation={openPopup}
    on:keydown|preventDefault|stopPropagation={openPopup}
    class="w-full border-2 border-dashed bg-white {errorCSS} flex cursor-pointer justify-center rounded-lg border px-8 py-4"
  >
    {#if src && !isUploading}
      <img class="h-20 object-cover" {src} alt="Your logo" />
    {:else if isUploading}
      <div class="my-2 flex flex-col items-center justify-center gap-4">
        <i class="fa-solid fa-spinner animate-spin text-lg"></i>
      </div>
    {:else}
      <div class="my-2 flex flex-col items-center justify-center gap-4">
        <i class="fa fa-upload text-3xl text-gray-500 text-gray-500" aria-hidden="true"></i>
        <div class="text-md rounded border border-2 border-gray-500 px-4 py-2 text-gray-500">Upload File</div>
        <div class="text-md text-center text-gray-400">PNG, JPEG, and SVG formats, up to 1024px in width</div>
      </div>
    {/if}
  </div>
  {#if exceedsMaxWidth}
    <div class="text-sm text-red-600">
      The file is too large. Please upload images with a maximum width of <strong>1024px</strong>.
    </div>
  {/if}
</div>
